import { render, staticRenderFns } from "./CompanyContactAddEditDialog.vue?vue&type=template&id=12c62829&scoped=true"
import script from "./CompanyContactAddEditDialog.vue?vue&type=script&lang=js"
export * from "./CompanyContactAddEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c62829",
  null
  
)

export default component.exports